import { Directive, HostListener, ElementRef, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
    selector: '[thousandSeparator]',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ThousandSeparatorDirective),
        multi: true
    }]
})
export class ThousandSeparatorDirective implements ControlValueAccessor {
    private onChange: (val: number) => void;
    private onTouched: () => void;

    constructor(private el: ElementRef) {}

    writeValue(value: number): void {
        this.el.nativeElement.value = (value != null && !isNaN(value))
            ? this.formatForBlur(value)
            : '0.00';
    }

    registerOnChange(fn: any): void { this.onChange = fn; }
    registerOnTouched(fn: any): void { this.onTouched = fn; }

    @HostListener('input', ['$event'])
    onInput(event: any): void {
        const input = event.target;
        const cursorPos = input.selectionStart;
        const oldLen = input.value.length;

        let raw = input.value.replace(/,/g, '').replace(/[^0-9.]/g, '');
        
        const parts = raw.split('.');
        
        if (parts.length > 2) {
            parts.pop(); 
        }

        if (parts.length > 1) {
            parts[1] = parts[1].substring(0, 2);
        }

        const intFormatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const formatted = parts.length > 1
            ? intFormatted + '.' + parts[1]
            : intFormatted;

        input.value = formatted;

        const newLen = formatted.length;
        const newPos = Math.max(0, cursorPos + (newLen - oldLen));
        input.setSelectionRange(newPos, newPos);

        const numVal = parseFloat(parts.join('.'));
        if (this.onChange) {
            this.onChange(!isNaN(numVal) ? numVal : 0);
        }
    }

    @HostListener('blur')
    onBlur(): void {
        if (this.onTouched) this.onTouched();
        
        const raw = this.el.nativeElement.value.replace(/,/g, '');
        const num = parseFloat(raw);
        const finalNum = !isNaN(num) ? num : 0;
        
        this.el.nativeElement.value = this.formatForBlur(finalNum);
        
        if (this.onChange) this.onChange(finalNum);
    }

    private formatForBlur(val: number): string {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(val);
    }
}